export default  {"src":"/_next/static/image/public/images/icons/profile.3d1a4cf1861da0bcf24bb1688f316a0e.svg","height":20,"width":20};